import { FileWarning, Image, Video, Clapperboard } from 'lucide-react';

export type ProfileContentTab = 'minis' | 'longs' | 'posts' | 'reports';

interface ProfileTabsProps {
  active: ProfileContentTab;
  counts: Record<ProfileContentTab, number>;
  isSelf: boolean;
  reportPendingCount: number;
  onChange: (tab: ProfileContentTab) => void;
}

const tabs = [
  { id: 'minis', label: 'MiniS', Icon: Clapperboard },
  { id: 'longs', label: 'Longs', Icon: Video },
  { id: 'posts', label: 'Posts', Icon: Image },
  { id: 'reports', label: 'Reports', Icon: FileWarning }
] as const;

export function ProfileTabs({ active, counts, isSelf, reportPendingCount, onChange }: ProfileTabsProps) {
  return (
    <nav aria-label="Profile content" className="sticky top-0 z-20 -mx-4 border-b border-slate-200 bg-white/95 px-2 backdrop-blur sm:-mx-6 sm:px-4">
      <div className="flex">
        {tabs.filter(tab => tab.id !== 'reports' || isSelf).map(({ id, label, Icon }) => (
          <button key={id} type="button" onClick={() => onChange(id)} aria-current={active === id ? 'page' : undefined} className={`relative flex min-h-12 flex-1 items-center justify-center gap-1.5 px-2 text-xs font-bold transition-colors ${active === id ? 'text-blue-900' : 'text-slate-500 hover:text-slate-800'}`}>
            <Icon className="h-4 w-4" />
            <span>{label}</span>
            <span className="rounded-full bg-slate-100 px-1.5 py-0.5 text-[10px] tabular-nums text-slate-600">{counts[id]}</span>
            {id === 'reports' && reportPendingCount > 0 && <span className="h-2 w-2 rounded-full bg-rose-500" aria-label={`${reportPendingCount} reports awaiting response`} />}
            <span className={`absolute inset-x-3 bottom-0 h-0.5 origin-center bg-blue-900 transition-transform duration-200 ${active === id ? 'scale-x-100' : 'scale-x-0'}`} />
          </button>
        ))}
      </div>
    </nav>
  );
}
